import { Skeleton } from '@chakra-ui/react'
import React from 'react'
import Layout from './Layout'
import client from '../client.js'
import {useParams} from 'react-router-dom'
import {useState, useEffect, useCallback} from 'react';
import  '../components/recipe.css'

function Recipe() {

  const params = useParams()
  let recipeID = params.recipeId
  

  const [recipe, setRecipe] = useState([])
  const [isRecipeLoading, setIsRecipeLoading] = useState(false)

  const cleanUpRecipe = useCallback((rawData) => {

    const cleanRecipe = rawData.map((recipe) => {

      const {sys, fields} =recipe
      const {id} = sys
      const recipeTitle = fields.recipeName
      const recipeImage = fields.recipePicture.fields.file.url
      const recipeIngredients = fields.recipeItems
      const recipeDirections = fields.recipeDirections
      const recipeTime = fields.totalTime
      const mealType = fields.mealType
      const cleanedRecipe = {id, recipeTitle, recipeImage, recipeIngredients,recipeDirections, recipeTime, mealType}
      return cleanedRecipe
    })
    setRecipe(cleanRecipe)
    // console.log("this is cleaned" + cleanRecipe)

},[])




  const fetchRecipe = useCallback (async () => {

    
    try {

        const response = await client.getEntries({content_type:'recipeNookRecipes'})
        // console.log(recipeID)
        // console.log("next is intial respone grab:")
        // console.log( response)
        const responseData = response.items.filter((recipe) => recipe.sys.id === recipeID )

        // console.log("initial grab" + responseData)


        if (responseData) {
            cleanUpRecipe(responseData)
            // console.log("after cleanup" + responseData)
            setIsRecipeLoading(true)
        } else {
            setRecipe([])
            setIsRecipeLoading(false)
        }
        
      } 
      catch (error) {
          console.log(error)
          setIsRecipeLoading(false)
      }
  },[cleanUpRecipe,recipeID])

useEffect(() => {
  fetchRecipe()
}, [fetchRecipe])

// console.log( recipe)


  return (
    <Layout>
        <Skeleton isLoaded={isRecipeLoading}>
       
          <section id='recipe' >
                {recipe.map((item) => {
                    const {id, recipeTitle, recipeImage, recipeDirections,recipeIngredients, recipeTime} = item

                return (
                        <article key={id} >
                          <div className='leftPane' style={{background:`url(${recipeImage})`, backgroundSize:'cover', width:'350px', height:'750px',backgroundPosition:'center'}} alt={recipeTitle} />
                          <div className='rightPane'>
                              <h1 className='font-nunito font-bold text-rosemadder -mb-4 mt-4 text-4xl'>{recipeTitle}</h1>
                              <h3>Total Cook Time: {recipeTime} minutes</h3>
                              <h3>Ingredients</h3>
                              <ul className='ingredients  '>
                              {
                                recipeIngredients.split(',').map((ingredients)=> {
                                  return <li className='text-base'>{ingredients}</li>
                                })
                              }
                              </ul>
                              <h3 className='mt-0'>Directions:</h3>
                              <p className='directions'>{recipeDirections}</p>
                            </div>
                        </article>
                        
                       
                )
                })}
            </section>
        </Skeleton>
    </Layout>
  )
}

export default Recipe